import { render } from "./Personnages.vue?vue&type=template&id=77e3772a"
import script from "./Personnages.vue?vue&type=script&lang=js"
export * from "./Personnages.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__